<template>
  <aw-sf-recommendation
    page="category"
    :bordered="isOnWhiteCard"
    :for-items="categoryName"
    :analytics-banner-interaction="analyticsBannerInteraction"
    :analytics-measurable="analyticsMeasurable"
  />
</template>

<script setup>
  import cmsPageComponentMixin from '~~/common/mixins/cmsPageComponentMixin.js';
  import AwSfRecommendation from '~~/common/components/Common/AwSfRecommendation.vue';
  import { useCategoryStore } from '~~/common/stores/category.js';

  import analyticsBannerInteractionMixin from '~~/common/mixins/analyticsBannerInteractionMixin.js';

  defineProps({
    ...cmsPageComponentMixin.props,
    ...analyticsBannerInteractionMixin.props,
    content: {
      type: Object,
      required: true,
    },
  });

  const categoryName = useCategoryStore().getCategoryFromTree?.name;
</script>
